export default __webpack_public_path__ + "static/media/23.da276ed9.jpg";